import { useContext, useState } from "react"
import { useDispatch } from "react-redux"
import { NavigationContext } from "../../Context/NavigationContext"
import { getDataReader } from "../../livedataFuncs"
import { lddStateObject, setLawyerListState, setListDataState, } from "../../redux/reducer"
import { lddGlobalSessionInfo, NavObjectType } from "../navigationTypes"
import { MortgageContext } from "./MortgageLender"
import { getBranchData, selectBranchLink } from "./MortgageLenderFuncs"
import { LenderContactType, MortgageLenderItem } from "./MortgageLenderTypes"
import { NewMortgageLender } from "./NewMortgageLender"
import { useAppSelector } from "../../redux/hooks"
import { Dispatch, } from "react";
import { AnyAction } from "redux";
import * as ParseXML from 'xml-parse-from-string';
import { ThirdPartyDispatch } from "../ThirdPartyList/ThirdPartyFuncs";

export type MortgageLenderSubBranchType = {
    LenderEntry: MortgageLenderItem,
    typeOfLender: "Misc" | "Mortgage_lender",
    showSubBranch?: boolean,
}

export const MortgageLenderSubBranch = (props: MortgageLenderSubBranchType) => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g: lddStateObject) => g.SessionInfo);
    const [showSubBranch, setShowSubBranch] = useState<boolean>(props.showSubBranch || false);
    const [showLenderEditPage, setShowLenderEditPage] = useState<boolean>(false);
    const dispatch = useDispatch();
    const fullLenderData: MortgageLenderItem[] = useAppSelector((g: lddStateObject) => g.ListData["MortgageLenderList"]);
    function setData(newBranches: LenderContactType[]) {
        const newLenderList = [...fullLenderData];
        const findIndex = newLenderList.findIndex((lender) => lender.LDDLenderID === props.LenderEntry['LDDLenderID']);
        newLenderList[findIndex].branches = [...newBranches];
        dispatch(setListDataState("MortgageLenderList", newLenderList));
    }
    const nav = useContext(NavigationContext);
    let mortgageNodesLength = 0;
    let id, psm;
    if (livedataRootContainer?.dataRoot) {
        const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
        mortgageNodesLength = DataReaderObj.getMortgageNodesLength();
        if (mortgageNodesLength < 1) {
            mortgageNodesLength = 1;
        }
        id = DataReaderObj.getAppId();
        psm = DataReaderObj.getPSM();
    }
    const navToMortgageTab: NavObjectType = {
        component: "main",
        url: "lfmaster.asp",
        params: {
            "tb": "TPAppXML",
            "formasp": "purfileedit",
            "id": id,
            "PSM": psm,
        },
        controller: {
            tabName: "Mortgages",
            tabNumber: mortgageNodesLength,
        },
    }

    const handlerShowBranch = () => {
        if (props.LenderEntry.branches.length == 0) {
            getBranchData(
                props.LenderEntry['LDDLenderID'],
                SESSION_INFO,
                setData,
                props.LenderEntry,
                setShowSubBranch,
                false
            );
        } else {
            setShowSubBranch(!showSubBranch);
        }
    }

    const callBranch = () => {
        getBranchData(
            props.LenderEntry['LDDLenderID'],
            SESSION_INFO,
            setData,
            props.LenderEntry,
            setShowSubBranch,
            true
        );
    }

    const clickHandler = async () => {
        if (props.typeOfLender !== 'Misc') {
            navToMortgageTab.label = props.LenderEntry.Name;
            var returnVal = selectBranchLink(props.LenderEntry);
            if (!returnVal) {
                return;
            }
            await dispatch(setLawyerListState(false));
            nav(navToMortgageTab);
        }
    }

    return (
        <>
            <tr>
                {props.LenderEntry['BranchCount'] > 0 ?
                    <td onClick={handlerShowBranch} width="20px">
                        <i className={!showSubBranch ? 'fa-regular fa-chevron-down' : 'fa-regular fa-chevron-up'}></i>
                    </td>
                    : <td></td>
                }
                <td onClick={clickHandler}>
                    <span style={(props.LenderEntry['Active'] === "N" || props.LenderEntry['Active'] === "n") ? { fontStyle: 'italic', color: 'gray' } : {}}>{props.LenderEntry['Name']}</span>
                </td>
                <td>
                    <i className="fa-solid fa-plus" onClick={() => { setShowLenderEditPage(true); }}></i>
                </td>
            </tr>
            {(props.LenderEntry.branches && showSubBranch) &&
                <>{props.LenderEntry.branches.map(subbranchListLink(dispatch, props.LenderEntry, livedataRootContainer?.dataRoot, nav, props.typeOfLender))}</>
            }
            {showLenderEditPage &&
                <MortgageContext.Consumer>
                    {
                        value =>
                            <NewMortgageLender
                                fileListColumns={value.fileListColumns}
                                searchTable={value.searchTable}
                                setShowLender={setShowLenderEditPage}
                                LenderEntry={props.LenderEntry}
                                callBranch={callBranch}
                                subBranch={undefined}
                                typeOfLender={props.typeOfLender}
                            />
                    }
                </MortgageContext.Consumer>
            }
        </>
    )
}

function subbranchListLink(
    dispatch: Dispatch<AnyAction>,
    lenderEntry: MortgageLenderItem,
    dataroot: Element,
    nav: (navObject: NavObjectType) => void,
    typeOfLender: "Misc" | "Mortgage_lender",
) {
    return (SubBranch: LenderContactType) => {
        let id, psm, currNodeLength;
        if (dataroot) {
            const DataReaderObj = getDataReader(dataroot);
            id = DataReaderObj.getAppId();
            psm = DataReaderObj.getPSM();
        }
        let xmldata = ParseXML(SubBranch.XMLData);
        const editBranch: NavObjectType = {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": id,
                "PSM": psm,
            },
            controller: {
                tabName: "Mortgages",
                autoClickClassName: '#reactEditMortgage',
            },
        };
        const mortgageScreen: NavObjectType = {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": id,
                "PSM": psm,
            },
            controller: {
                tabName: "Mortgages",
                tabNumber: 1
            },
        };
        const branchClickHandler = async () => {
            try {
                await nav(mortgageScreen);
                SubBranch.LenderProgramID = xmldata.getElementsByTagName('Lender')[0].getAttribute('LenderProgramID');
                const returnVal = await selectBranchLink(lenderEntry, SubBranch);
                if (!returnVal) {
                    return;
                }
                await ThirdPartyDispatch(dispatch, 'MortgageLender', false);
                if (dataroot) {
                    const DataReaderObj = getDataReader(dataroot);
                    currNodeLength = DataReaderObj.getMortgageNodesLength();
                    const tab = currNodeLength > 1 ? currNodeLength - 1 : 1;
                    editBranch.controller.tabNumber = tab;
                    editBranch.controller.autoClickClassNamePosition = tab;
                }
                nav(editBranch);
            } catch (e) {
                console.log('Mortgage failed to import');
            }
        }

        return (
            <tr key={`${xmldata.getElementsByTagName('Lender')[0].getAttribute('Lender')}-${SubBranch.LenderContactID}`}>
                <td></td>
                <td onClick={branchClickHandler} style={{ paddingLeft: '25px' }}>
                    {typeOfLender !== 'Misc' ?
                        <>
                            {`- ${(SubBranch.Branch === '' || SubBranch.Branch === undefined || SubBranch.Branch === null) ? "No Branch Name" : SubBranch.Branch}`}
                            {!(SubBranch.TransitNum === undefined || SubBranch.TransitNum === null) && `, #${SubBranch.TransitNum}`}
                        </>
                        :
                        (`- ${xmldata.getElementsByTagName('Lender')[0].getAttribute('Lender')},${SubBranch.Branch},#${SubBranch.TransitNum}`)
                    }
                </td>
                <td>
                    <i className="fa-solid fa-pen" onClick={branchClickHandler}></i>
                </td>
            </tr>
        )
    }
}
